import { render, staticRenderFns } from "./_OptionGroupDialog.vue?vue&type=template&id=1aa6e37a&scoped=true&"
import script from "./_OptionGroupDialog.vue?vue&type=script&lang=js&"
export * from "./_OptionGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa6e37a",
  null
  
)

export default component.exports